import { CloudXIntegrationDataSchema } from "@redotech/redo-model/integrations/returns/cloudx/types";
import { null as zNull } from "zod";

export const postCloudXIntegration = {
  name: "postCloudXIntegration" as const,
  input: CloudXIntegrationDataSchema,
  output: zNull(),
};
